import React from 'react';
import { Route } from 'react-router-dom';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

const Status = ({ code, children }) => (
    <Route render={({ staticContext }) => {
        if (staticContext) {
            // eslint-disable-next-line no-param-reassign -- react-router's documented way to pass the HTTP status code up to the SSR server
            staticContext.status = code;
        }

        return children;
    }}
    />
);

Status.propTypes = exact({
    code: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
});

export default Status;
